import get from 'lodash/get'
import type { TreeGroupOptions } from './types'
import cloneDeep from 'lodash/cloneDeep'

export function groupTree<T, G = string, A = any>(
  root: T,
  groupFunc: ((node: T) => G) | null | undefined,
  aggregateFunc: (groupId: G, nodes: T[]) => A,
  options?: TreeGroupOptions
): Record<string, A> {
  const childrenName = options?.childrenName ?? 'items'
  const startsFromRoot = options?.startsFromRoot ?? true
  const clonedRoot = cloneDeep(root)

  const flatNodes: T[] = []

  function flatten(node: T) {
    flatNodes.push(node)
    const children = get(node, childrenName, []) as T[]
    for (const child of children) {
      flatten(child)
    }
  }

  if (clonedRoot) {
    if (startsFromRoot) {
      flatten(clonedRoot)
    } else {
      const children = get(clonedRoot, childrenName, []) as T[]
      for (const child of children) {
        flatten(child)
      }
    }
  }

  const grouped: Record<string, T[]> = {}

  for (const node of flatNodes) {
    let groupId: G | string

    if (typeof groupFunc === 'function') {
      groupId = groupFunc(node) as string
    } else {
      groupId = '_'
    }

    const key = String(groupId)
    grouped[key] ??= []
    grouped[key].push(node)
  }

  const aggregated: Record<string, A> = {}

  for (const [groupId, nodes] of Object.entries(grouped)) {
    aggregated[groupId] = aggregateFunc(groupId as G, nodes)
  }

  return aggregated
}
